module.exports = __webpack_public_path__ + "static/media/Hospitality_52.bd4fb46b.jpg";